<template>
	<div class="Credits">
		h1 {
		}
	</div>
</template>
<script>
export default {
	name: "Credits"
};
</script>
